<template>
  <div class="contacts">
    <div class="simple-contact">
      <div class="simple-contact__wrap">
        <h1 style="margin-bottom: 0;">404</h1>

        <div class="simple-contact__list">
          <div class="simple-contact__list__item" style="display: block;">
            La pagina cercata non è presente in questo sito.<br/><br/>
             <router-link :to="{ name: 'landing' }"
          @click="'landing'"
          @mouseover.native="updateMouseCursor('button')"
          @mouseout.native="updateMouseCursor('default')">Home page</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    lastRoute: undefined
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$data.lastRoute = from.name || 'landing'
    })
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';
@import '../assets/scss/mixins.scss';

.contact-bottom-button {
  position: fixed;
  transition: opacity .3s;
  bottom: 0;
  right: 0;
  margin: 6.25%;
  background-color: white;
  background-image: url('../assets/img/contact-ico.svg');
  background-size: 20px 50px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  z-index: 120;
  box-shadow: 2px 2px 10px rgba(0,0,0,.3);
  cursor: pointer;
  @include media(">=large"){
    margin: 3.25%;
  }
  &--close{
    background-image: url('../assets/img/contact-close-ico-revert.svg');
    background-size: 20px 20px;
    background-color: #0488a3;
    @include media(">=large"){
      background-image: url('../assets/img/contact-close-ico.svg');
    background-color: #0488a3;
    }
  }
}

.simple-contact__wrap {
  display: flex;
  flex-direction: column;
  color: #562581;
  background-color: #f2f2f2;
  min-height: 100vh;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 6.25%;
  @include media(">=large"){
    width: 75%;
    padding: 0 11.5%;
  }
  span {
    padding: 2.0rem;
  }

  h1 {
    margin-bottom: 5rem;
    font-size: 4.7rem;
    @include media(">=large") {
      font-size: 9rem;
    }

    @include media(">=xlarge") {
      font-size: 13rem;
    }
  }

  a {
    text-decoration: none;
    color: #562581;
    position: relative;
    font-size: 1.8rem;
    display: inline-block;
    padding-bottom: .25rem;
    transform: translate3d(0,0,0);
    transition: color .3s;
    &:after{
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #562581;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform .3s ease-out;
      @include media(">=large"){
        background: #EE2B55;
      }
    }

    &:hover{
      color: #EE2B55;
      &:after{
        transform: scaleX(1);
        transform-origin: left;
        background: #EE2B55;
      }
    }
    @include media(">=xlarge"){
      font-size: 2.4rem;
    }
  }
}

.simple-contact__list {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.simple-contact__list__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  margin-bottom: 5rem;

  @include media(">=large"){
    flex-direction: row;
  }
}

.simple-contact__list__item__left {
  margin-bottom: 2rem;
  font-size: 1.6rem;
  @include media(">=large"){
    width: 100px;
    margin-right: 6rem;
  }
  @include media(">=xlarge"){
    font-size: 2rem;
  }
}

.simple-contact__list__item__right {
  font-size: 1.8rem;
  @include media(">=xlarge"){
    font-size: 2.4rem;
  }
}
</style>
